import { api, getQueryString } from "../common/utils"
import {
  RATE_CARDS_CONFIG_ENDPOINT,
  RATE_CARDS_CONFIGS_ENDPOINT
} from "../common/constants"
import { RateCardsConfig, RateCardsConfigDetails } from "../types"

const rateCards = {
  getRateCardsConfigs: async (params: {
    brand_id?: string
  }): Promise<RateCardsConfig[]> => {
    const { data } = await api.get(
      `${RATE_CARDS_CONFIGS_ENDPOINT}${getQueryString(params)}`
    )
    return data
  },
  getRateCardsConfig: async (id: string): Promise<RateCardsConfigDetails> => {
    const { data } = await api.get(
      `${RATE_CARDS_CONFIG_ENDPOINT}${getQueryString({ id })}`
    )
    return data
  },
  updateRateCardsConfig: async (
    payload: Partial<RateCardsConfigDetails>
  ): Promise<{ status: string; message?: string }> => {
    const { data } = await api.post(RATE_CARDS_CONFIG_ENDPOINT, payload)
    return data
  },
  deleteRateCardsConfig: async (
    id: string
  ): Promise<{ status: string; message?: string }> => {
    const { data } = await api.delete(`${RATE_CARDS_CONFIG_ENDPOINT}?id=${id}`)
    return data
  }
}

export default rateCards
